module.exports = __webpack_public_path__ + "static/media/PublicSans-Regular.96ca2a24.woff2";